// Shared location label for campsite entities. Feed-sourced free camps carry a
// state + region but no town, so naive `${town}, ${state}` rendered
// "undefined, NSW" and `town || 'Unknown location'` rendered "Unknown location,
// NSW". Prefer town (with state), else the region (e.g. "Central Coast of
// NSW"), else the bare state.

interface MaybeAddress {
  town?: string | null;
  state?: string | null;
}
interface MaybeRegion {
  name?: string | null;
}

export function entityLocationLabel(
  addresses?: MaybeAddress[] | null,
  regions?: MaybeRegion[] | null,
  fallback = 'Australia',
): string {
  const a = addresses && addresses[0];
  if (a?.town) {
    return [a.town, a.state].filter(Boolean).join(', ');
  }
  return regions?.[0]?.name || a?.state || fallback;
}
